
import React from 'react';
import { getScoreTier } from '@/utils/scoreCalculator';
import { cn } from '@/lib/utils';
import ScoreGauge from './ScoreGauge';
import { Button } from './ui/button';

export interface DomainScore {
  domain: string;
  score: number;
  timestamp: number;
}

interface HistoryListProps {
  history: DomainScore[];
  onSelect: (domain: string) => void;
  onClear: () => void;
  className?: string;
}

const HistoryList: React.FC<HistoryListProps> = ({ 
  history, 
  onSelect, 
  onClear,
  className 
}) => {
  if (history.length === 0) {
    return (
      <div className={cn("p-4 rounded-lg bg-gray-50 text-center", className)}>
        <p className="text-gray-500">No domains analyzed yet</p>
      </div>
    );
  }

  return (
    <div className={cn("space-y-3", className)}>
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-medium">Domain History</h3>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={onClear}
          className="text-xs"
        >
          Clear
        </Button>
      </div>
      
      <div className="grid gap-2 max-h-64 overflow-y-auto pr-2">
        {history.map((item) => {
          const { tier, emoji } = getScoreTier(item.score);
          
          return (
            <div 
              key={`${item.domain}-${item.timestamp}`}
              className="flex items-center justify-between p-3 rounded-lg bg-white shadow-sm border border-gray-100 hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => onSelect(item.domain)}
            >
              <div className="flex items-center">
                <ScoreGauge score={item.score} size="sm" showLabel={false} className="mr-3" />
                <div>
                  <div className="font-medium">{item.domain}</div>
                  <div className="text-xs text-gray-500 flex items-center">
                    {emoji} {tier}
                  </div>
                </div>
              </div>
              <div className="text-lg font-bold">
                {item.score}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HistoryList;
